// import React, { useEffect } from "react";
// import WOW from "wow.js";
// import "animate.css";
// import { Link } from "react-router-dom";

// const Section02 = ({ oddData }) => {
//   useEffect(() => {
//     new WOW().init();
//   }, []);

//   return (
//     <section className="leadership about-area pt-70">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-6">
//             <div
//               className="cards parentcard cardWidth bg-white p-4 wow fadeInLeftBig"
//               data-wow-duration="1s"
//             >
//               <div className="section-title">
//                 <div className="line"></div>
//                 <h3 className="title">
//                   {oddData.Title1}
//                   {oddData.Title2 && <span> {oddData.Title2}</span>}
//                 </h3>
//               </div>

//               <p className="text">
//                 {oddData.text || "Explore detailed features and capabilities."}
//               </p>

//               <Link to={oddData.path}>
//                 <p className="main-btn">Features</p>
//               </Link>
//             </div>
//           </div>
//           <div className="col-lg-6">
//             <div
//               className="about-image text-center mt-50 wow fadeInRightBig"
//               data-wow-duration="1s"
//             >
//               <img
//                 className="img-fluid section-img"
//                 src={oddData.image}
//                 alt="product"
//               />
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section02;

import React, { useEffect } from "react";
import WOW from "wow.js";
import "animate.css";
import { Link } from "react-router-dom";

const Section02 = ({ oddData }) => {
  useEffect(() => {
    new WOW().init();
  }, []);

  return (
    <section className="leadership about-area pt-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div
              className="cards parentcard cardWidth bg-white p-4 wow fadeInLeftBig"
              data-wow-duration="1s"
            >
              <div className="section-title">
                <div className="line"></div>
                <h3 className="title">
                  {oddData.Title1}
                  {oddData.Title2 && <span> {oddData.Title2}</span>}
                </h3>
              </div>

              <p className="text" style={{ textAlign: 'justify', lineHeight: '1.8', color: '#555' }}>
                {oddData.text || "Explore detailed features and capabilities."}
              </p>

              <Link to={oddData.path}>
                <p className="main-btn">Features</p>
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="about-image text-center mt-50 wow fadeInRightBig"
              data-wow-duration="1s"
            >
              <img
                className="img-fluid section-img"
                src={oddData.image}
                alt="product"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Section02;
